import { TemplateRef } from '@angular/core';
import {
  CellTemplateContext,
  ColumnBuilder,
  DatasetTableConfig,
  editAction,
  TableConfigBuilder,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { DatabaseTagsModel } from '@models/database-tags.model';

export type EntityTagCellContext = CellTemplateContext<DatabaseTagsModel.EntityTagDocument>;

export interface CreateEntitiesFilteredByTagTableConfigDependencies {
  nameCellTemplate: TemplateRef<EntityTagCellContext>;
  typeCellTemplate: TemplateRef<EntityTagCellContext>;
  entityTypeLabels: { [key in DatabaseTagsModel.EntityType]: string };
  entityTypesEnum: typeof DatabaseTagsModel.EntityType;
  onRowClick: (row: DatabaseTagsModel.EntityTagDocument) => void;
  onEditAction: (row: DatabaseTagsModel.EntityTagDocument) => void;
}

export function createEntitiesFilteredByTagTableConfig(
  dependencies: CreateEntitiesFilteredByTagTableConfigDependencies,
): DatasetTableConfig<DatabaseTagsModel.EntityTagDocument> {
  const builder = new ColumnBuilder<DatabaseTagsModel.EntityTagDocument>();

  return new TableConfigBuilder<DatabaseTagsModel.EntityTagDocument>()
    .columns([
      builder
        .column('name')
        .label('DATABASE_TAGS.ENTITIES_TABLE.NAME')
        .width('minmax(150px, 1fr)')
        .cellTemplate(dependencies.nameCellTemplate)
        .cardMode('label-only')
        .mobileVisible()
        .build(),

      builder
        .column('entityType')
        .label('DATABASE_TAGS.ENTITIES_TABLE.TYPE')
        .width('minmax(120px, 0.8fr)')
        .cellTemplate(dependencies.typeCellTemplate)
        .cardMode('label-only')
        .mobileVisible()
        .build(),
    ])
    .actions([
      editAction<DatabaseTagsModel.EntityTagDocument>({
        tooltip: 'COMMON.EDIT',
        visible: (row) => row.entityType === dependencies.entityTypesEnum.EVENT,
      }),
    ])
    .trackBy('_id')
    .rowHeight(72)
    .onRowClick(dependencies.onRowClick)
    .build();
}
